import FormMobileAssistant from './container'
import FormSucceed from './after_effects/succeed_container'
export { FormMobileAssistant, FormSucceed }
export default FormMobileAssistant